import { Component } from '@angular/core';

import { MessengerEmailComponent } from '../messages/messenger/messenger.email.component';

@Component({
  selector   : 'bookings-request-send-email',
  template: require('./bookings.request.send-email.component.html')
})
export class BookingsRequestSendEmailComponent extends MessengerEmailComponent {}
